import { IReelsEngineProvider, ISlotGameEngine, ISlotGameEngineProvider } from '@cgs/machines';
import { Container } from '@cgs/wge';
import { CorsicaReelsEngine } from './corsica-reels-engine';

export class CorsicaReelsEngineComponent implements IReelsEngineProvider, ISlotGameEngineProvider {
  private _reelsEngine: CorsicaReelsEngine;

  public get reelsEngine(): CorsicaReelsEngine {
    return this._reelsEngine;
  }

  public get gameEngine(): ISlotGameEngine {
    return this._reelsEngine;
  }

  constructor(
    container: Container,
    useSounds: boolean = true,
    animatedIcons: number[],
    animName: string
  ) {
    this._reelsEngine = new CorsicaReelsEngine(container, useSounds, animatedIcons, animName);
  }
}
